import { Component, Input } from '@angular/core';
import { ColumnOptions } from '@shared';

@Component({
  selector: 'app-column-manager',
  templateUrl: './column-manager.component.html',
  styleUrl: './column-manager.component.scss',
})
export class ColumnManagerComponent {
  @Input()
  columns: ColumnOptions[] = [];

  @Input()
  view!: string;

  toggleColumnVisibility(column: ColumnOptions) {
    column.hidden = !column.hidden;
  }
}
